import { useBucket } from '@mc/experiments-react'
import { useStaticData } from '@mc/static-data-react'
import { useMCProExperiment } from '../../prcng-1194_v1_mc_pro_tier'
import { useMCProPromoExperiment } from '../../prcng-1270_v1_mc_pro_promo'
import { INTRO_PRICING_FLAG_NAME } from '../constants'

export const useExperiment = () => {
  const { isGift } = useStaticData<{ isGift: boolean }>()
  const bucket = useBucket(INTRO_PRICING_FLAG_NAME)
  const { isVariant: isMCProVariant } = useMCProExperiment()
  const { isInMCProPromoVariant } = useMCProPromoExperiment()

  return {
    isVariant: bucket?.startsWith('variant') && !isGift,
    bucket: !isGift ? bucket : undefined,
    isIntroPricingUpgradeFlowEnabled:
      bucket === 'variant_4' &&
      !isGift &&
      (!isMCProVariant || isInMCProPromoVariant),
    isIntroPricingPrePurchase:
      !isGift && bucket !== 'variant_4' && bucket?.startsWith('variant'),
  }
}
